import React, { useEffect, useState } from 'react';
import './JobChip.css';

// JobChip — WHICH JOB AM I IN? 2026-08-31.
//
// Braeden: "people are going to get on the app, and expect that its eitehr a
// new chat or somethign weve previously worked on, its up to aria and or
// orginization system to classify what the user is doing"
//
// The backend now files every turn into a job (middleware/ariaWorkspace.js)
// and hands the answer back with `workspace` on it. That was invisible: the
// filing happened, and the person had no way to know which job they were in
// or that a new one had just been opened for them.
//
// So: one quiet chip. It names the job, it says "new" for a few seconds when
// she just opened one, and clicking it opens that job's canvas. It does not
// ask anything and it never blocks — the work carries on whether or not
// anybody looks at it.
export default function JobChip({ workspace, onOpen }) {
  const [freshId, setFreshId] = useState(null);

  useEffect(() => {
    if (!workspace || !workspace.created) return undefined;
    setFreshId(workspace.id);
    // The "new" flag is a moment, not a state. Left up, it becomes wallpaper
    // and stops meaning anything.
    const t = setTimeout(() => setFreshId(null), 6000);
    return () => clearTimeout(t);
  }, [workspace && workspace.id, workspace && workspace.created]);

  if (!workspace || !workspace.name) return null;
  const isNew = freshId === workspace.id;
  const borrowed = workspace.fromOtherJob;

  return (
    <div className="jobchip-wrap">
      <button
        type="button"
        className={'jobchip' + (isNew ? ' jobchip--new' : '')}
        onClick={() => onOpen && onOpen(workspace)}
        title={'Open ' + workspace.name}
      >
        <span className="jobchip__dot" aria-hidden="true" />
        <span className="jobchip__label">{isNew ? 'Started' : 'Working on'}</span>
        <span className="jobchip__name">{workspace.name}</span>
      </button>
      {borrowed && (
        // She used a fact from a DIFFERENT job. Saying where it came from is
        // the same rule the source panel follows: a fact with no origin is a
        // guess wearing a number.
        <div className="jobchip__borrowed">
          {borrowed.key.replace(/_/g, ' ')} {borrowed.value} — from {borrowed.job}
        </div>
      )}
    </div>
  );
}
